import React, { Component, Fragment } from 'react';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Typo, HR } from 'tmt-ui-kit';

import { actions as filterActions } from '~/redux/reducers/filter';
import { actions as sessionActions } from '~/redux/reducers/session';
import { actions as tripActions } from '~/redux/reducers/trip';

import HeadTag from '~/components/Head/HeadTag';
import Topic from '~/components/Topic/Topic';
// import BannerTopic from '~/components/Row/Topics/BannerTopic';
import FilterMenu from '~/components/Filter/FilterMenu';
import NotResult from '~/components/Filter/NotResult';

import { getActivityOptionsFromValues } from '~/utils/filter';
import { pipe } from '~/utils/function';

const BannerTopic = dynamic(
  () => import(/* webpackChunkName: "Topic.BannerTopic.components" */'../../components/Row/Topics/BannerTopic'),
  { loading: () => null }
);

const NewSearchContainer = styled(Container.InnerContainer)`
  margin-bottom: 40px;
`;

const NotResultContainer = styled.div`
  margin-top: 42px;
`;

const enhance = connect(
  state => ({
    activityInfo: state.filter.activityInfo,
    filterInfo: state.filter.filterInfo,
    isError: state.filter.isError
  }),
  {
    getActivity: filterActions.getActivity,
    setFilterInfo: filterActions.setFilterInfo,
    logFilterActivity: filterActions.logFilterActivity,
    getActivityByCity: filterActions.getActivityByCity,
    addToConversionSource: sessionActions.addToConversionSource,
    logClickCard: tripActions.logClickCard,
    logImpressCard: tripActions.logImpressCard,
    logImpressTopic: tripActions.logImpressTopic,
    logClickSeeMore: tripActions.logClickSeeMore,
    logScrollEnd: tripActions.logScrollEnd,
  }
);
class NewSearch extends Component {
  static propTypes = {
    url: PropTypes.object,
    activityInfo: PropTypes.array,
    setFilterInfo: PropTypes.func,
    logFilterActivity: PropTypes.func,
    filterInfo: PropTypes.object
  };

  static async getInitialProps({ store, query, res }) {
    const { activity, city } = query;
    try {
      let defaultActivity;
      if (city) {
        const { data: activities } = await store.dispatch(filterActions.getActivityByCity(city));
        const hasActivity = activities && activities.find(c => c === activity) !== undefined;
        defaultActivity = hasActivity
          ? activity
          : pipe(
            option => (option ? option.value : undefined)
          )(getActivityOptionsFromValues(activities)[0]);
      }

      await store.dispatch(filterActions.getActivity(city || false, defaultActivity || 'popular'));
    } catch (e) {
      if (res) res.statusCode = 404;
    }
    return { };
  }

  render() {
    const { url } = this.props;
    const banner = {
      title: url.query.city ? url.query.city : "Let's Explore Thailand Like Locals"
    };
    return (
      <Fragment>
        <HeadTag
          title="Let's Explore Thailand Like Locals - TakeMeTour"
        />
        <BannerTopic
          url={url}
          objects={banner}
          setFilterInfo={this.props.setFilterInfo}
          logFilterActivity={this.props.logFilterActivity}
          filterInfo={this.props.filterInfo}
          useNewFilter
        />
        <FilterMenu
          url={url}
          filterInfo={this.props.filterInfo}
          setFilterInfo={this.props.setFilterInfo}
          logFilterActivity={this.props.logFilterActivity}
          isShowFilterMenuBottom
        />
        <NewSearchContainer>
          {this.props.activityInfo.map((data, index) => {
            const objActivityInfo = {
              contains: 'filterTrips',
              trip_ids: data.trips,
              omit_title: true,
              index,
              _id: data._id
            };
            return (
              <Fragment key={`topic-${index}-${data.city}`}>
                <Typo.HeaderOne>{data.city}</Typo.HeaderOne>
                <Topic
                  {...this.props}
                  key={`topic-${index}`}
                  topic={objActivityInfo}
                  index={index}
                  isOmitTitle
                />
                {this.props.activityInfo.length - 1 > index && <HR />}
              </Fragment>
            );
          })}
          {this.props.activityInfo.length <= 0 && (
            <NotResultContainer>
              <NotResult />
            </NotResultContainer>
          )}
        </NewSearchContainer>
      </Fragment>
    );
  }
}

export default enhance(NewSearch);
